import { SkuResult, WishlistModel } from "@core/services/api.service";

export class WishlistsModel {
    totalPrice: number;
    items: WishlistModel[] = [];
}